import "react-toastify/dist/ReactToastify.css";
import { useContext, useEffect } from "react";
import { Loading } from "../../shared/components"
import { loadDataService } from "./services"
import { Main } from "./components"
import { DashboardContext } from "./context/DashboardContext";
import { LoadingContext } from "../../shared/context/LoadingContext"


export default function Dashboard() {

  const { data, setData, dateRange } = useContext(DashboardContext);
  const { isLoading, setIsLoading } = useContext(LoadingContext);

  useEffect(() => {
    handleLoadingData();
  }, [dateRange]);

  async function handleLoadingData() {
    setIsLoading(true);
    const response = await loadDataService(dateRange.start, dateRange.end);
    if (response) {
      setData(response.data);
    }
    setIsLoading(false);
  }

  return (
    <>
      {isLoading || data === null ? <Loading /> : <Main />}
    </>
  )
}